var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasImgStoryError)?_c('BubbleImage',{attrs:{"url":_vm.storyUrl},on:{"error":_vm.onImageLoadError}}):(!_vm.hasVideoStoryError)?_c('BubbleVideo',{attrs:{"url":_vm.storyUrl},on:{"error":_vm.onVideoLoadError}}):_c('InstagramStoryErrorPlaceHolder')
}
var staticRenderFns = []

export { render, staticRenderFns }